import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UiWindowService } from '@myapp/modules/fwcore/services';

import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { AuthPerm } from '@myapp/features/admin/models';
import { TriStateCheckBoxComponent, ClickFilterComponent } from '@myapp/features/widgets';
import { UtcToLocalPipe } from '@myapp/modules/fwcore/pipes';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { FormFieldModule, NumericTextBoxModule, TextAreaModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { NullableStringDirective } from '../../../../../modules/fwcore/directives';

@Component({
  selector: 'app-auth-tree-editor',
  templateUrl: './auth-tree-editor.component.html',
  styleUrls: ['./auth-tree-editor.component.scss'],
  standalone: true,
  imports: [DialogModule, ReactiveFormsModule, TabStripModule, FormFieldModule, LabelModule
    , TextBoxModule, TriStateCheckBoxComponent, ClickFilterComponent, NgClass, NumericTextBoxModule, TextAreaModule, NgIf
    , ButtonModule, AsyncPipe, UtcToLocalPipe, NullableStringDirective]
})

export class AuthTreeEditorComponent implements OnChanges {

  public editForm: FormGroup = new FormGroup({
    moduleName: new FormControl(),
    hierarchyName: new FormControl(),
    lastModifiedByName: new FormControl(),


    id: new FormControl(),
    parentId: new FormControl(),
    hierarchyId: new FormControl(),
    hierarchyLinkId: new FormControl(),
    authLinkId: new FormControl(),
    lastModifiedOn: new FormControl(),

    pbiWorkSpaceId: new FormControl(),
    pbiDashboardId: new FormControl(),
    pbiChartId: new FormControl(),
    pbiPageSection: new FormControl(),
    pbiNavigation: new FormControl(false),

    moduleId: new FormControl(),
    moduleTarget: new FormControl(),
    moduleInfo: new FormControl(),
    moduleAppTagId: new FormControl(),
    moduleHierarchyName: new FormControl(),

    intAppCode: new FormControl(),
    name: new FormControl('', Validators.required),
    sortOrder: new FormControl(1),
    isActive: new FormControl(true),
    isConfigLabel: new FormControl(false),
    licenseId: new FormControl(),
    info: new FormControl(),
    appTag: new FormControl(),
    appTagId: new FormControl(null),
    target: new FormControl(''),
    metaData: new FormControl(),
    description: new FormControl(),
    intDescription: new FormControl(),
    isLocked: new FormControl()

  });

  /*-------------------------- Input / Outputs --------------------------------*/

  @Input() editDataItem: AuthPerm | null | undefined;

  @Input() public set isViewOnlyEditor(item: boolean) {
    if (item) {
      this.editForm.disable();
      this.isReadOnlyCustomControl = true;
    }
    else {
      this.editForm.enable();
      this.isReadOnlyCustomControl = false;
    }
  }

  @Output() cancel: EventEmitter<undefined> = new EventEmitter();
  @Output() save: EventEmitter<AuthPerm> = new EventEmitter();

  /*-------------------------- public properties / methods --------------------*/

  public isReadOnlyCustomControl: boolean = false;

  /*-------------------------- Constructor  --------------------------*/

  constructor(public afUiWin: UiWindowService) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.editDataItem) {
      this.editForm.patchValue(this.editDataItem as { [key: string]: AuthPerm });
    }

  }

  /*--------------------------- event handlers  --------------------------*/

  public onCancel(e: PointerEvent): void {

    e.preventDefault();
    this.closeForm();
  }

  public onSave(e: PointerEvent): void {

    e.preventDefault();
    this.save.emit(this.editForm.value)
  }

  /*--------------------------- internal functions  --------------------------*/

  protected closeForm(): void {

    this.cancel.emit();

  }

}
